import { Injectable } from '@angular/core';
import { v4 as UUIDv4 } from 'UUID';
import _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class BrowserTabVisibilityChangeService {
  private RECENT_ACTIVE_BROWSER_TAB_IDS_NAME = 'recent-active-browser-tab-ids';
  private TAB_ID_KEY_NAME = 'tab-id-key';

  public removeTabFromRecentlyActive() {
    const browserTabUniqueId = this.getBrowserTabUniqueId();
    let recentActiveBrowserTabIds = this.getRecentActiveBrowserTabIds();
    recentActiveBrowserTabIds = this.removeFromTheList(recentActiveBrowserTabIds, browserTabUniqueId);
    this.setRecentActiveBrowserTabIds(recentActiveBrowserTabIds);
  }

  public isBrowserTabRecentlyActive(): boolean {
    const browserTabUniqueId = this.getBrowserTabUniqueId();
    const recentActiveBrowserTabIds = this.getRecentActiveBrowserTabIds();

    return recentActiveBrowserTabIds[0] == browserTabUniqueId;
  }

  public setCurrentTabAsActive() {
    if (!document.hidden) {
      const browserTabUniqueId = this.getBrowserTabUniqueId();

      let recentActiveBrowserTabIds = this.getRecentActiveBrowserTabIds();
      recentActiveBrowserTabIds = this.removeFromTheList(recentActiveBrowserTabIds, browserTabUniqueId);
      recentActiveBrowserTabIds = _.take([browserTabUniqueId, ...recentActiveBrowserTabIds], 10);

      this.setRecentActiveBrowserTabIds(recentActiveBrowserTabIds);
    }
  }

  public resetTabUniqueId() {
    const navigation: any = performance.getEntriesByType('navigation')[0];
    const navigationType = navigation.type;
    if (navigationType == 'back_forward') {
      sessionStorage.removeItem(this.TAB_ID_KEY_NAME);
      this.getBrowserTabUniqueId();
    }
  }

  private getBrowserTabUniqueId(): string {
    let idFromSessionStorage = sessionStorage.getItem(this.TAB_ID_KEY_NAME);
    if (!idFromSessionStorage) {
      idFromSessionStorage = UUIDv4();
      sessionStorage.setItem(this.TAB_ID_KEY_NAME, idFromSessionStorage);
    }

    return idFromSessionStorage;
  }

  private removeFromTheList(array: string[], tabId: string): string[] {
    return _.filter(array, function (item) {
      return item != tabId;
    });
  }

  private getRecentActiveBrowserTabIds(): string[] {
    if (localStorage[this.RECENT_ACTIVE_BROWSER_TAB_IDS_NAME]) return JSON.parse(localStorage[this.RECENT_ACTIVE_BROWSER_TAB_IDS_NAME]);
    else return [];
  }

  private setRecentActiveBrowserTabIds(input: string[]) {
    localStorage[this.RECENT_ACTIVE_BROWSER_TAB_IDS_NAME] = JSON.stringify(input);
  }
}
